<template>
  <div
    data-qa="lpu_affiliation"
  >
    <a
      data-qa="lpu_affiliation_lpu_type_link"
      class="text-body-1 text--text link-decoration-none"
      :href="reverseFullL10N({
        name: 'lpulist',
        args: {
          language: urlLang,
          town_translit: lpu.town.translit,
          lpu_type_translit: lpu.lputype.translit,
        },
      })"
    >{{ tDynamic(lpu.lputype, 'name') }}</a>

    <template v-if="lpu.lpuset">
      <span class="text-body-1 text-secondary--text">
        · {{ tStatic('в составе сети') }}
      </span>
      <a
        data-qa="lpu_affiliation_lpuset_link"
        class="text-body-1 primary--text link-decoration-none"
        :href="reverseFull({
          name: 'lpuset',
          args: [lpu.lpuset.town.translit, lpu.lpuset.translit],
        })"
      >
        {{ tDynamic(lpu.lpuset, 'name') }}
      </a>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

defineProps<{
  lpu: Lpu
}>()

const { urlLang }: CommonContextStore = useContextStore()
const { reverseFullL10N, reverseFull } = useURLStore()
</script>
